// @material-ui/core components
import { makeStyles } from "tss-react/mui";

// core components
import Button from "../CustomButtons/Button";
import styles from "../../styles/jss/nextjs-material-kit/pages/forumsStyle.js";
import Link from "next/link";
import {updateQueryString} from "../../util/url";
import React from "react";
import {useRouter} from "next/router";

const useStyles = makeStyles()(styles);

export default function ForumsLoginBarrier(props) {
    const { classes, cx } = useStyles();
    const router = useRouter();

    return (
        <div className={classes.loginBarrier}>
            <div className={classes.modalContent}>
                <p className={classes.modalTitle}>Sign up or log in</p>
                <p className={classes.modalText}>It seems you're not a member yet. Why don't you register for a free account or login?</p>
                <div className={classes.loginBarrierButtons}>
                <Link
                  href={updateQueryString(updateQueryString(router.asPath, "register", null), "redirectUrl", router.asPath)}
                  shallow={true}
                >
                    <Button className={cx(classes.darkButton + " " + classes.wideButton)}>Sign up</Button>
                </Link>
                <Link
                  href={updateQueryString(updateQueryString(router.asPath, "login", null), "redirectUrl", router.asPath)}
                  shallow={true}
                >
                    <Button className={cx(classes.outlineButton + " " + classes.wideButton)}>Login</Button>
                </Link>
                </div>
            </div>
        </div>
    )
}

